import { LabTestsEntityOrProceduresEntity } from '../store/types/prescription';
import { CREATE_LAB_TEST_CART } from './constants';
import fetchWithRefresh from './fetchWithRefresh';
import { AddressObj } from './getLabTestSlot';
import { Cart } from './getLabTestsOrder';

interface Request {
    pxid?: string;
    address?: AddressObj;
    docid: string;
    patientid: string;
    discount: number;
    eka_lab?: LabTestsEntityOrProceduresEntity[];
    no_of_members?: number;
    vendor_id?: string;
}

export interface Response {
    success: boolean;
    data: LabOption[];
    labData: LabTestsEntityOrProceduresEntity[];
    paymodes: string[];
    in_clinic_sample_collection: boolean;
    error?: string;
}

export interface LabOption {
    finalprice: number;
    mrp: number;
    vendor: string;
    vendor_id: string;
    sku: Cart[];
    extra_charges: {
        [k: string]: number;
    };
    unavailableLabTests: LabTestsEntityOrProceduresEntity[];
    max_discount: number;
    fare_dict: FareDict;
    max_members_allowed: number;
    isForSmartPackages?: boolean;
}

export interface FareDict {
    discount_percent: number;
    discount_amount: number;
    mrp: number;
    eka_net_price: number;
    min_sell_price: number;
    max_sell_price: number;
    total_price: number;
    extra_charges: ExtraCharges;
    taxes: Taxes;
    doc_max_discount_percentage: number;
}

export interface ExtraCharges {
    total: number;
    details: Detail[];
}

export interface Taxes {
    total: number;
    details: Detail[];
}

export interface Detail {
    type: string;
    amount: number;
}

export default (docid: string, request: Request): Promise<Response> => {
    return fetchWithRefresh(CREATE_LAB_TEST_CART(docid), {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
